// Single source of truth for the app version string shown in the sidebar
// footer, mobile drawer, and `/api/health` cross-check. Reads directly from
// package.json so bumping is a one-line edit in that file — no forgotten
// duplicate strings.
import pkg from "../../package.json";

export const APP_VERSION = pkg.version;

// Optional shorter label for very cramped mobile UI. Currently we just show
// the full semver.
export const APP_VERSION_LABEL = `v${APP_VERSION}`;
